;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';
import type { HTMLAttributes, ReactNode } from 'react';

export interface PageHeaderCardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  contentClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  actionsClassName?: string;
  /** The title/actions row. Pass `sm:items-start` to top-align actions with the title. */
  rowClassName?: string;
  /** Rendered full width beneath the title/actions row, inside the same card. */
  children?: ReactNode;
}

export function PageHeaderCard({
  title,
  description,
  actions,
  className,
  contentClassName,
  titleClassName,
  descriptionClassName,
  actionsClassName,
  rowClassName,
  children,
  ...props
}: PageHeaderCardProps) {
  const row = (
    <>
      <div className={cn('flex min-w-0 flex-col gap-2', contentClassName)}>
        <p
          className={cn(
            'text-[22px] leading-6 font-semibold text-neutral-200 dark:text-neutral-100',
            titleClassName
          )}
        >
          {title}
        </p>
        {description ? (
          <p
            className={cn(
              'text-base leading-5 font-normal text-grey-600 dark:text-grey-100',
              descriptionClassName
            )}
          >
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div
          className={cn(
            'flex w-full sm:self-stretch flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:justify-end sm:gap-4',
            actionsClassName
          )}
        >
          {actions}
        </div>
      ) : null}
    </>
  );

  return (
    <div
      className={cn(
        'bg-grey-25 dark:bg-grey-1000 flex w-full flex-col gap-4 rounded-[28px] p-6 shadow-[0px_429px_120px_0px_rgba(42,43,65,0.00),0px_17px_38px_0px_rgba(42,43,65,0.05)] sm:p-7',
        // Without a second row the card *is* the row, exactly as before `children`
        // existed — so `className` keeps meaning what it always meant for callers.
        !children && 'sm:flex-row sm:items-center sm:justify-between',
        !children && rowClassName,
        className
      )}
      {...props}
    >
      {children ? (
        <div
          className={cn(
            'flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
            rowClassName
          )}
        >
          {row}
        </div>
      ) : (
        row
      )}
      {children}
    </div>
  );
}
